import { makeStyles } from "@material-ui/core";
import { ITableColumn } from "components/interfaces";
import { Row } from "./";
import SubTable from "./SubTable";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    "&.expanded": {
      backgroundColor: theme.palette.gray[200],
      "& > *": {
        fontWeight: 500,
      },
    },
  },
  expandedTable: { backgroundColor: theme.palette.gray[200] },
}));

interface IProps {
  /** Define os detalhes serão exibidos ou ocultos. */
  open: boolean;
  /** Dados da linha. */
  row: any[];
  /** Dados dos detalhes da linha. */
  rowDetails: any[];
  /** Colunas da linha. */
  columns: ITableColumn[];
  /** Colunas dos detalhes da linha. */
  subColumns: ITableColumn[];
  /** Elemento que será colocado na última coluna da linha e que contém as ações que podem ser realizadas na mesma. */
  actionCell?: any;
  /** Tamanho da tabela de detalhes da linha. Deve ser medido por número de colunas, e caso não seja informa, será obtido o total de colunas da linha principal. */
  subColumnLength?: number;
  /** Número de colunas em branco que serão adicionadas antes das colunas dos detalhes da linha. */
  blankColumns?: number;
}

/** Linha com estrutura que exibe/esconde os detalhes da mesma linha.
 * @category Components
 */
const CollapsibleRow = ({
  open,
  row,
  rowDetails,
  columns,
  subColumns,
  actionCell,
  subColumnLength,
  blankColumns,
}: IProps) => {
  const classes = useRowStyles();
  const [headerRow, ...subTableRows] = rowDetails;
  const totalSubColumns = actionCell
    ? subColumns.length + 1
    : subColumns.length;

  return (
    <>
      <Row
        className={open ? [classes.root, "expanded"].join(" ") : classes.root}
        columns={columns}
        row={row}
        actionCell={actionCell}
      />
      <SubTable
        classes={{
          expandedTable: classes.expandedTable,
          row: classes.root,
          headerRow: classes.root,
        }}
        open={open}
        colSpan={subColumnLength || totalSubColumns}
        blankColumns={blankColumns || 0}
        columns={subColumns}
        headerRow={headerRow}
        rows={subTableRows}
      />
    </>
  );
};

export default CollapsibleRow;
